$(document).ready(function () {
    "use strict";

    const mapTab = $(".js_mapTab");

    if (mapTab.length > 0) {
        mapTab.click(function() {
            mapTab.removeClass("active");
            $(this).addClass("active");

            $(".tabMap").hide();
            $("#" + $(this).data("id")).show();
        })
    }

    const viewOnMap = $(".js_viewOnMap");

    if (viewOnMap.length > 0) {
        viewOnMap.click(function() {
            $(".js_mapTab:first-child").click();

            $('html, body').animate({
                scrollTop: $(".mapsContainer").offset().top - 100
            }, 500);
        })
    }
});
